<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $tc("user", 1) }}</div>
      <router-link class="btn-blue" to="/user-management/users"
        >{{ $tc("user", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <form class="row">
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.personalDetailsForm
          >
            <span class="fs">
              {{ $tc("Personal Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id=" personalDetailsForm"
            class="mt-2"
            v-model="sectionCollapse.personalDetailsForm"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.first_name"
                      name="firstname"
                      id="firstname"
                      v-validate="'required|alpha_spaces'"
                      :title="$t('user_NameTooltip')"
                    />
                    <label>{{ $t("name") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
                  <!-- v-b-tooltip.hover -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('firstname')">{{
                    errors.first("firstname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="userDetails.middle_name"
                      v-validate="{ regex: /^[a-zA-Z- ]*$/ }"
                      name="middlename"
                      id="middlename"
                      :title="$t('user_MiddleName')"
                    />
                    <label>{{ $t("middlename") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_MiddleName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('middlename')">{{
                    errors.first("middlename")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.last_name"
                      type="text"
                      name="lastname"
                      id="lastname"
                      v-validate="'required|alpha_spaces'"
                      :title="$t('user_LastName')"
                    />
                    <label>{{ $t("lastname") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_LastName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('lastname')">{{
                    errors.first("lastname")
                  }}</span>
                </p>
              </div>
              <!-- v-if="this.flag.isDistributor === false" -->
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3"> -->
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_employee_code"
                      type="text"
                      name="employeeid"
                      id="employeeid"
                      v-validate="'required'"
                      :title="$t('user_Employee')"
                    />
                    <!-- required|alpha_num -->
                    <label>{{ $t("employeeid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Employee')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('employeeid')">{{
                    errors.first("employeeid")
                  }}</span>
                </p>
              </div>
              <!-- v-if="this.flag.isDistributor === false" -->
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Gender && selected.Gender.length > 0
                          ? 'shift-up'
                          : ''
                      "
                    >
                      {{ $tc("gender", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Gender"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Gender')"
                    >
                      <b-dropdown-item
                        v-for="(gender, genderIndex) in Gender"
                        :key="genderIndex"
                        v-on:click="onSelectHandler('gender', gender)"
                        name="selectgender"
                        id="selectgender"
                        >{{ gender.gender }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Gender')" /> -->
                </div>

                <p class="error_message">
                  <span v-if="submitted && selected.Gender.length == 0">{{
                    $t("selectgender")
                  }}</span>
                </p>
              </div>
              <!-- v-if="this.flag.isDistributor === false" -->
              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        userDetails.employeementSelectedType &&
                        userDetails.employeementSelectedType.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $t("employeetype") }}</label
                    >
                    <b-dropdown
                      :text="userDetails.employeementSelectedType"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_EmployementType')"
                    >
                      <b-dropdown-item
                        v-for="(value, typeIndex) in employeementType"
                        :key="typeIndex"
                        v-on:click="onSelectEmployeementTypeHandler(value)"
                        >{{ value }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmployementType')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      userDetails.employeementSelectedType.length == 0
                    "
                    >{{ $t("selectemptype") }}</span
                  >
                </p>
              </div>

              <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="userDetails.up_dob"
                  v-on:click="clearSelectedDate()"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="userDetails.up_dob"
                  name="dob"
                  id="dob"
                  v-validate="'required'"
                  :disabledDates="{
                        from: new Date(2010, 11, 31),
                      }"
                ></Datepicker>
                <label
                  :class="typeof userDetails.up_dob === 'object' ? 'active': ''"
                >{{ $t('dob') }}</label>
              </div>
            </div>
            <Tooltip :title="$t('user_DateOfBirth')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('dob')">{{ errors.first('dob') }}</span>
          </p>
        </div>

        <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="userDetails.up_doj" v-on:click="cleardoj()">✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="userDetails.up_doj"
                  name="doj"
                  id="doj"
                  v-validate="'required'"
                  :disabledDates="{
                        to: previousdate,
                        from: futuredate,
                      }"
                ></Datepicker>
                <label
                  :class="typeof userDetails.up_doj === 'object' ? 'active': ''"
                >{{ $t('doj') }}</label>
              </div>
            </div>
            <Tooltip :title="$t('user_DateOfJoining')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('doj')">{{ errors.first('doj') }}</span>
          </p>
        </div>-->

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <div class="add-datepicker">
                      <button
                        class="btn-clearDate"
                        v-if="userDetails.up_dob"
                        v-on:click.prevent.stop="clearSelectedDate()"
                        :title="$t('user_DateOfBirth')"
                      >
                        ✖
                      </button>
                      <Datepicker
                        :monday-first="true"
                        ref="programaticOpen"
                        v-model="userDetails.up_dob"
                        name="dob"
                        id="dob"
                        :typeable="true"
                        :disabledDates="{
                          from: new Date(2010, 11, 31),
                        }"
                      ></Datepicker>
                      <label
                        :class="
                          typeof userDetails.up_dob === 'object' ? 'active' : ''
                        "
                        >{{ $t("dob") }}</label
                      >
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_DateOfBirth')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <div class="add-datepicker">
                      <button
                        class="btn-clearDate"
                        v-if="userDetails.up_doj"
                        v-on:click.prevent.stop="cleardoj()"
                        :title="$t('user_DateOfJoining')"
                      >
                        ✖
                      </button>
                      <Datepicker
                        :monday-first="true"
                        ref="programaticOpen"
                        v-model="userDetails.up_doj"
                        name="doj"
                        id="doj"
                        :typeable="true"
                        :disabledDates="{
                          to: previousdate,
                          from: futuredate,
                        }"
                      ></Datepicker>
                      <!-- v-validate="'required'" -->

                      <label
                        :class="
                          typeof userDetails.up_doj === 'object' ? 'active' : ''
                        "
                        >{{ $t("doj") }}</label
                      >
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_DateOfJoining')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_address1"
                      type="text"
                      name="address"
                      id="address"
                      v-validate=""
                      :title="$t('user_Address')"
                    />
                    <!-- v-validate="'required|regex: /^[_]*$/|alpha_dash|alpha_num|alpha_spaces'" -->
                    <label>{{ $t("address") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Address')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('address')">{{
                    errors.first("address")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Country && selected.Country.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("country", 1) }}</label
                    >
                    <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                  name="selectcountry"
                  id="selectcountry"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown>-->
                    <multiselect
                      :options="Countries"
                      v-model="selected_country"
                      :searchable="true"
                      label="country_name"
                      track-by="country_name"
                      placeholder=""
                      @input="onSelectHandler('country', $event)"
                      :allowEmpty="false"
                      :showLabels="false"
                      :title="$t('user_Country')"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(country, countryIndex) in Countries"
                :key="countryIndex"
                v-on:click="onSelectHandler('country',country)"
                name="selectcountry"
                id="selectcountry"
              >{{ country.country_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Country')" />
          </div>
          <p
            v-if="submitted && selected.Country == 'Select Country'"
            class="error_message"
          >{{ this.messagecountry }}</p>
        </div>-->

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.State && selected.State.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("state", 1) }}</label
                    >
                    <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state,stateIndex) in States"
                  :key="stateIndex"
                  @click="onSelectHandler('state',state)"
                  name="selectstate"
                  id="selectstate"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown>-->
                    <multiselect
                      :options="States"
                      v-model="selected_state"
                      :searchable="true"
                      label="state_name"
                      track-by="state_name"
                      placeholder=""
                      :allowEmpty="false"
                      :showLabels="false"
                      @input="onSelectHandler('state', $event)"
                      :title="$t('user_State')"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(state,stateIndex) in States"
                :key="stateIndex"
                @click="onSelectHandler('state',state)"
                name="selectstate"
                id="selectstate"
              >{{ state.state_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_State')" />
          </div>
          <p
            v-if="submitted && selected.State == 'Select State'"
            class="error_message"
          >{{ this.messagestate }}</p>
        </div>-->

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.city_name"
                      type="text"
                      name="city_name"
                      id="city_name"
                      :title="$t('user_Cities')"
                    />
                    <label>{{ $tc("city", 1) }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Cities')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(city,cityIndex) in Cities"
                :key="cityIndex"
                @click="onSelectHandler('city',city)"
                name="selectcity"
                id="selectcity"
              >{{ city.city_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Cities')" />
          </div>
          <p
            v-if="submitted && selected.City == 'Select City'"
            class="error_message"
          >{{ this.messagecity }}</p>
        </div>-->

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.zipcode"
                      type="number"
                      name="zipcode"
                      id="zipcode"
                      :title="$t('user_ZipCode')"
                    />
                    <label>{{ $t("zipcode") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_ZipCode')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.email_id"
                      type="email"
                      name="a_email_id"
                      id="a_email_id"
                      v-validate="'required|email'"
                      :title="$t('user_EmailId')"
                    />
                    <label>{{ $t("emailid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmailId')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('a_email_id')">{{
                    errors.first("a_email_id")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.up_alt_contact_no"
                      type="text"
                      name="phoneno"
                      id="phoneno"
                      v-validate="'numeric|min:7'"
                      :title="$t('user_phone')"
                    />
                    <label>{{ $t("phone") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_phone')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('phoneno')">{{
                    errors.first("phoneno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material row">
                    <div class="col-4">
                      <b-dropdown
                        :text="
                          userDetails.country_mob_code
                            ? userDetails.country_mob_code
                            : org_code
                            ? org_code
                            : 'Code'
                        "
                        variant="dropdown-curve"
                        class="w-100 text-center mr-3"
                        placeholder="code"
                        name="countrycode"
                        id="countrycode"
                        :title="$t('user_mobile')"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Code"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in countryList"
                          :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                          "
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="col-8 pl-1">
                      <input
                        placeholder="."
                        v-model="userDetails.mobile_no"
                        type="text"
                        name="mobileno"
                        id="monileno"
                        v-validate="'required|numeric|min:8|max:14'"
                        :title="$t('user_mobile')"
                      />
                      <label>{{ $t("mobiles") }}</label>
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_mobile')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && !userDetails.country_mob_code">{{
                    "Country Code Required."
                  }}</span>
                  <span>{{ " " }}</span>
                  <span v-if="submitted && errors.has('mobileno')">{{
                    errors.first("mobileno")
                  }}</span>
                </p>
              </div>
            </div>
          </b-collapse>
        </section>

        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.loginDetails
          >
            <span class="fs">
              {{ $tc("Login Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="loginDetails"
            class="mt-2"
            v-model="sectionCollapse.loginDetails"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.username"
                      v-validate="{
                        required: 'required',
                        // regex: /^[a-zA-Z0-9-_@.]+$/,
                        regex: /^(?=.{5,30}$)[a-zA-Z0-9@._-]*$/,
                      }"
                      type="text"
                      autocomplete="off"
                      onfocus="this.removeAttribute('readonly');"
                      readonly
                      name="username"
                      id="username"
                      :title="$t('user_Username')"
                    />
                    <!-- v-validate="'required|alpha_num'" -->
                    <label>{{ $t("username") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Username')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('username')">{{
                    errors.first("username")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="userDetails.password"
                      type="password"
                      name="password"
                      id="password"
                      v-validate="
                        userDetails.use_only_authenticator === 'N'
                          ? {
                              required: 'required',
                              regex:
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                            }
                          : ''
                      "
                      autocomplete="off"
                      onfocus="this.removeAttribute('readonly');"
                      readonly
                      :title="$t('user_Password')"
                    />

                    <!-- \([1-9][0-9]\)\s[9-9]\d{4}\-\d{4} -->
                    <!-- /[((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{6,20})]/g -->
                    <!-- <br /> -->
                    <!-- {{userDetails.password}} -->
                    <!-- {required: true ,alpha_num: true, regex: /[a-zA-Z0-9!@#$]/g} -->
                    <label>{{ $t("password") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Password')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('password')">{{
                    errors.first("password")
                  }}</span>
                </p>
              </div>

              <!-- userpin -->
              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- required -->
                    <input
                      placeholder="."
                      v-model="userDetails.userpin"
                      v-validate="'required|numeric|min:4|max:8'"
                      type="text"
                      name="userpin"
                      id="userpin"
                      :title="$t('userpin')"
                    />
                    <label>{{ $t("userpin") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('userpin')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('userpin')">{{
                    errors.first("userpin")
                  }}</span>
                </p>
              </div>
              <!-- passwordpin -->
              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- required -->
                    <input
                      placeholder="."
                      v-model="userDetails.passwordpin"
                      v-validate="'required|numeric|min:4|max:8'"
                      type="password"
                      name="passwordpin"
                      id="passwordpin"
                      :title="$t('passwordpin')"
                    />
                    <label>{{ $t("passwordpin") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('passwordpin')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('passwordpin')">{{
                    errors.first("passwordpin")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Role && selected.Role.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("role", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Role"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Roles')"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Roles"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchRoles()"
                          v-on:keydown="onSearchRoles()"
                          v-on:search="onSearchRoles()"
                          v-model="searchRole"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(role, roleIndex) in Roles"
                        :key="roleIndex"
                        @click="onSelectHandler('role', role)"
                        name="selectrole"
                        id="selectrole"
                        >{{ role.role_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Roles')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.Role.length == 0">{{
                    $t("select_user_Roles")
                  }}</span>
                </p>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[4, 8].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="gap: 20px">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.pos_access"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">POS Access</label>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.fnb_access"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">FNB Access</label>
                  </div>
                </div>
                <p class="error_message"></p>
              </div>
              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[13].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="font-size: 13px">
                  <b-form-radio
                    :value="'N'"
                    class="j-radio"
                    v-model="userDetails.order_pickup_access_only"
                  >
                    <div>
                      <span>{{ "Kitchen Staff" }}</span>
                    </div>
                  </b-form-radio>
                  <strong class="mx-3">OR</strong>

                  <b-form-radio
                    :value="'Y'"
                    class="j-radio"
                    v-model="userDetails.order_pickup_access_only"
                  >
                    <div>
                      <span>{{ "Delivery Staff" }}</span>
                    </div>
                  </b-form-radio>
                </div>
                <p class="error_message"></p>
              </div>

              <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Role" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(role,roleIndex) in Roles"
                :key="roleIndex"
                @click="onSelectHandler('role',role)"
                name="selectrole"
                id="selectrole"
              >{{ role.role_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Roles')" />
          </div>
          <p
            v-if="submitted && selected.Role == 'Select Role'"
            class="error_message"
          >{{ this.messagerole }}</p>
        </div>-->

              <div
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3',
                  !flag.isDistributor ? '' : 'd-none',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Designation && selected.Designation.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc("designation", 1) }}</label
                    >
                    <b-dropdown
                      :text="selected.Designation"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Designation')"
                    >
                      <b-dropdown-item
                        v-for="(designation, designationIndex) in Designations"
                        :key="designationIndex"
                        @click="onSelectHandler('designation', designation)"
                        name="selectdesignation"
                        id="selectdesignation"
                        >{{ designation.designation }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Designation')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      selected.Designation &&
                      selected.Designation.length == 0
                    "
                    >{{ this.messagedesignation }}</span
                  >
                </p>
              </div>

              <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Designation" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(designation,designationIndex) in Designations"
                :key="designationIndex"
                @click="onSelectHandler('designation',designation)"
                name="selectdesignation"
                id="selectdesignation"
              >{{ designation.designation }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Designation')" />
          </div>
          <p
            v-if="submitted && selected.Designation == 'Select Designation'"
            class="error_message"
          >{{ this.messagedesignation }}</p>
        </div>-->
              <!-- v-if="this.loginRoleId == 1 || this.loginRoleId == 2" -->

              <div
                v-if="this.loginRoleId !== 3"
                :class="[
                  'col-lg-6 col-xl-3 align-self-center mb-3 ',
                  flag.isDistributor ? 'd-none' : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Cinemas && selected.Cinemas.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >Cinema</label
                    >
                    <b-dropdown
                      :text="selected.Cinemas"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Cinema')"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Cinema"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCinema()"
                          v-on:keydown="onSearchCinema()"
                          v-on:search="onSearchCinema()"
                          v-model="searchCinema"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(cinema, cinemaIndex) in Cinemas"
                        :key="cinemaIndex"
                        @click="onSelectHandler('cinema', cinema)"
                        name="selectcinema"
                        id="selectcinema"
                        >{{ cinema.cine_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Cinema')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      userDetails.cinema_id <= 0 &&
                      this.loginRoleId !== 3
                    "
                    >{{ messagecinema }}</span
                  >
                </p>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[4, 8].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="userDetails['store_id'] ? 'shift-up' : ''">{{
                      "Store Management"
                    }}</label>
                    <multiselect
                      :options="storeList"
                      v-model="userDetails['selectedStore']"
                      :searchable="true"
                      label="sm_store_name"
                      track-by="sm_id"
                      placeholder=""
                      @select="onSelectHandler('store', $event)"
                      @remove="removeHandler('store', $event)"
                      :title="'Select Store'"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      [4, 8].includes(userDetails.role_id) &&
                      !userDetails.store_id
                    "
                  >
                    Please select Store Management
                  </span>
                </p>
              </div>

              <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Cinemas" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(cinema,cinemaIndex) in Cinemas"
                :key="cinemaIndex"
                @click="onSelectHandler('cinema',cinema)"
                name="selectcinema"
                id="selectcinema"
              >{{ cinema.cine_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Cinema')" />
          </div>
          <p
            v-if="submitted && selected.Cinemas == 'Select Cinema'"
            class="error_message"
          >{{ this.messagecinema }}</p>
        </div>-->

              <!-- Employee -->

              <!-- Employee -->

              <!-- Department -->
              <div
                v-if="!flag.isDistributor"
                class="col-lg-6 col-xl-3 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Departments && selected.Departments.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $t("department") }}</label
                    >
                    <b-dropdown
                      :text="selected.Departments"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Department')"
                    >
                      <b-dropdown-item
                        v-for="(department, departmentIndex) in Departments"
                        :key="departmentIndex"
                        @click="onSelectHandler('department', department)"
                        name="selectdepartment"
                        id="selectdepartment"
                        >{{ department.dept_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Department')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <!-- <div v-if="!flag.isDistributor" class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selected.Departments" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(department,departmentIndex) in Departments"
                :key="departmentIndex"
                @click="onSelectHandler('department',department)"
                name="selectdepartment"
                id="selectdepartment"
              >{{ department.dept_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('user_Department')" />
          </div>
          <p
            v-if="submitted && selected.Departments == 'Select Department'"
            class="error_message"
          >{{ this.messagedepartment }}</p>
        </div>-->

              <!-- Distributor -->
              <div
                v-if="flag.isDistributor"
                class="col-lg-6 col-xl-3 align-self-center mb-3"
              >
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selected.Distributor && selected.Distributor.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >Select Distributor</label
                    >
                    <b-dropdown
                      :text="selected.Distributor"
                      variant="dropdown-curve"
                      class="w-100"
                      :title="$t('user_Distributor')"
                    >
                      <b-dropdown-item
                        v-for="(distributor, distributorIndex) in Distributors"
                        :key="distributorIndex"
                        @click="onSelectHandler('distributor', distributor)"
                        name="selectdepartment"
                        id="selectdepartment"
                        >{{ distributor.d_company_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_Distributor')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.Distributor.length == 0">{{
                    this.messagedistributor
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label for="file-selector" class="file-selector w-100">
                    <label
                      class="file-selector-label"
                      :class="
                        userDetails.user_profile_image_url.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $t("uploaduserimage") }}</label
                    >
                    <span>{{ userDetails.user_profile_image_url }}</span>
                    <input
                      v-on:change="uploadImage($event)"
                      type="file"
                      class="d-none"
                      id="file-selector"
                      :title="`Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`"
                    />
                  </label>

                  <!-- <Tooltip
              :title="
                `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
              "
            /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="selectedUserLocations ? 'shift-up' : ''"
                      >{{ "Other Locations" }}}</label
                    >
                    <multiselect
                      :options="USERSLOCATIONS"
                      v-model="selectedUserLocations"
                      :searchable="true"
                      :customLabel="setUserLocationLabel"
                      track-by="user_id"
                      placeholder="Select Other POS locations"
                      @select="onSelectLocations($event)"
                      :multiple="true"
                      :title="'OTHER USER LOCATION FOR POS'"
                    ></multiselect>
                  </div>
                  <!-- <Tooltip :title="'OTHER USER LOCATION FOR POS'" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-1 mb-2 d-flex">
                <b-form-checkbox
                  class="j-checkbox"
                  v-model="userDetails.TFA"
                  true-value="Y"
                  false-value="N"
                  @change="onChange2FA($event)"
                />
                <label class="mb-0">2FA</label>
              </div>

              <div class="d-flex col-lg-6 col-xl-3 mb-2">
                <b-form-checkbox
                  class="j-checkbox"
                  v-model="userDetails.use_only_authenticator"
                  true-value="Y"
                  false-value="N"
                  @change="onChangeUseOnlyAuthenticator($event)"
                />
                <label class="mb-0">Use Only Authenticator</label>
              </div>

              <div
                class="col-lg-6 col-xl-3 align-self-center mb-3"
                v-if="[13].includes(userDetails.role_id)"
              >
                <div class="d-flex align-items-center" style="gap: 20px">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="userDetails.is_premier_kitchen_user"
                      unchecked-value="N"
                      value="Y"
                      name="check-button"
                      class="j-checkbox mb-0"
                    />
                    <label class="mb-0">Premier Kitchen User</label>
                  </div>
                </div>
                <p class="error_message"></p>
              </div>
              <!-- Department -->

              <div class="col-md-12" v-if="showAuthenticatorQRCode">
                <h6>Please Scan This Code On Your Authenticator App</h6>

                <img :src="authenticatorQRCode" alt="" />
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/user-management/users"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";
import moment from "moment";
import DatePicker from "vue2-datepicker";

const selected = {
  Country: "",
  Gender: "",
  Departments: "",
  Cinemas: "",
  Role: "",
  State: "",
  City: "",
  Designation: "",
  Distributor: "",
};

var state = {
  date: new Date(1990, 1, 1),
};

export default {
  components: { DatePicker },
  data() {
    return {
      org_code: "",
      selectedUserLocations: [],
      USERSLOCATIONS: [],
      CinemasCopy: [],
      searchCinema: "",
      RolesCopy: [],
      searchRole: "",
      selected_country: null,
      selected_state: null,
      selected_city: null,
      btenable: false,
      employeementType: ["Contract", "Permanent", "Probation"],

      loginRoleId: null,
      loginCinema_Id: null,
      messagegender: "Please Select Gender.",
      messagecountry: "Please Select Country.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      messagerole: "Please Select Role.",
      messagedesignation: "Please Select Designation.",
      messagecinema: "Please Select Cinema.",
      messagedepartment: "Please Select Department.",
      messagedistributor: "Please Select Distributor.",
      errmsg: "",

      submitted: false,
      isRoleID: true,
      storeList: [],
      // cinema_id: "",
      customRegex: "//",
      userDetails: {
        username: "",
        pos_location_access: "",
        pos_access: "Y",
        fnb_access: "Y",
        order_pickup_access_only: "N",
        is_premier_kitchen_user: "N",
        user_profile_image_url: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        userpin: "",
        passwordpin: "",
        zipcode: "",
        store_id: null,
        selectedStore: "",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
        employeementSelectedType: "",
        TFA: "N",
        country_mob_code: "",
        use_only_authenticator: "N",
        authenticator_secret: "",
        city_name: "",
      },
      selected: selected,
      isDisabled: null,
      showAuthenticatorQRCode: false,
      authenticatorQRCode: null,

      flag: {
        isDistributor: false,
      },

      Distributors: [],

      //
      Genres: [],
      GenresMethod: {
        GET: "/admin/",
        tableName: "ms_genre",
        urlKey: "genres",
      },
      Gender: [],
      GenderMethod: {
        GET: "/admin/",
        tableName: "ms_gender",
        urlKey: "gender",
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },

      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },

      Designations: [],
      DesignationsMethods: {
        GET: "/admin/",
        tableName: "ms_designations",
        urlKey: "designations",
      },
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Departments: [],
      DepartmentsMethods: {
        GET: "/admin/",
        tableName: "ms_departments",
        urlKey: "departments",
      },
      futuredate: "",
      previousdate: "",
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: "",
      sectionCollapse: {
        personalDetailsForm: true,
        loginDetails: true,
      },
    };
  },
  computed: {
    usernameLengthWarning() {
      const length = this.userDetails.username.length;
      return length > 0 && (length < 5 || length > 30);
    },
  },

  beforeMount() {
    this.userDetails.country_mob_code =
      this.$store.getters.getOrganizationDetails.org_contact_no_code;
    this.org_code =
      this.$store.getters.getOrganizationDetails.org_contact_no_code;
    let obj = this.secureStore.get("USINFO");
    console.log(this.$store.getters.getOrganizationDetails, "Test store");
    const { role_id, cinema_id } = this.secureStore.get("USINFO");
    if (role_id) {
      this.loginRoleId = role_id;
      this.loginCinema_Id = cinema_id;
      this.getGenderList();
      this.getGenreList();
      this.getCountriesList();
      this.getRolesList();
      this.getDesignationList();
      this.getDepartmentList();
      this.getDistributorsList();
      let roleid = role_id;
      let obj = cinema_id;

      if (true) {
        this.isRoleID = false;
        this.getCinemasList(obj);
      } else {
        this.getCinemasList(obj);
      }

      /////////////////////////////////////////////////////
      this.futuredate = new Date();
      this.previousdate = new Date();
      this.previousdate.setFullYear(this.previousdate.getFullYear() - 50);
      // console.log("previousdate :", previousdate);
      this.futuredate.setDate(this.futuredate.getDate() + 7);
      this.onResetForm();
    } else {
      this.$router.push({ path: "/access-denied" });
    }
  },
  mounted() {
    const { userid } = this.$route;
    this.getUsersList();
  },
  methods: {
    getStoreManagement(cinema_id) {
      this.storeList = [];
      this.userDetails["selectedStore"] = "";
      this.userDetails["store_id"] = null;
      MasterService.GetStoreManagement({
        cine_id: cinema_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getUsersList: function () {
      MasterService.GetUsers({ roles: [4, 8] })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.USERSLOCATIONS = data.Records;
            this.USERSLOCATIONS = this.USERSLOCATIONS.filter((x) => {
              return x.role_id == 4 || x.role_id == 8;
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    setUserLocationLabel(e) {
      return `${e.first_name} ${e.last_name ? e.last_name : ""} ${
        e.cine_name ? "(" + e.cine_name + ")" : ""
      }`;
    },
    onSelectLocations(location) {
      console.log("onSelect USER location", location);
    },
    onSearchCode() {
      // this.country_mob_code == '966'
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchRoles: function () {
      if (this.searchRole && this.searchRole.length > 0) {
        this.Roles = this.RolesCopy.filter((x) => {
          if (
            x.role_name.toLowerCase().includes(this.searchRole.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Roles = this.RolesCopy;
      }
    },
    onSelectEmployeementTypeHandler: function (value) {
      this.userDetails.employeementSelectedType = value;
    },
    onResetForm: function () {
      this.userDetails = {
        username: "",
        user_profile_image_url: "",
        pos_location_access: "",
        pos_access: "Y",
        fnb_access: "Y",
        order_pickup_access_only: "N",
        is_premier_kitchen_user: "N",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        userpin: "",
        passwordpin: "",
        zipcode: "",
        store_id: null,
        selectedStore: "",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
        use_only_authenticator: "N",
        authenticator_secret: "",

        employeementSelectedType: "",
      };
      this.selected = {
        Country: "",
        Gender: "",
        Departments: "",
        Cinemas: "",
        Role: "",
        State: "",
        City: "",
        Designation: "",
        Distributor: "",
        employeementSelectedType: "",
      };
      // console.log("this.selected 1:", this.selected);
    },
    clearSelectedDate: function () {
      this.userDetails.up_dob = "";
    },
    cleardoj: function () {
      this.userDetails.up_doj = "";
    },
    onSelectHandler: function (type, value) {
      if (type == "gender") {
        this.selected.Gender = value.gender;
        this.userDetails.gender_id = value.gender_id;
      } else if (type == "country") {
        this.selected.Country = value.country_name;
        this.userDetails.country_id = value.country_id;
        this.userDetails.country_mob_code = value.country_mob_code;
        this.selected_state = null;
        this.selected_city = null;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.userDetails.state_id = value.state_id;
        this.selected_city = null;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.userDetails.city_id = value.city_id;
      } else if (type == "role") {
        this.flag.isDistributor = false;
        this.loginRoleId = null;

        console.log("value.role_name :", value.role_name);
        this.selected.Role = value.role_name;
        this.userDetails.role_id = value.role_id;
        value.role_id === 9 ? (this.loginRoleId = 3) : "";
        if (value.role_is_cinema_level === "N") {
          value.role_is_cinema_level === "N" ? (this.loginRoleId = 3) : "";
          this.userDetails.cinema_id = 0;
        } else if (value.role_id === 9) {
          this.flag.isDistributor = true;
        }
        this.searchRole = "";
        this.onSearchRoles();
      } else if (type == "designation") {
        this.selected.Designation = value.designation;
        this.userDetails.designation_id = value.designation_id;
      } else if (type == "cinema") {
        this.selected.Cinemas = value.cine_name;
        this.userDetails.cinema_id = value.cine_id;
        this.getStoreManagement(value.cine_id);
        this.searchCinema = "";
        this.onSearchCinema();
        // console.log("this.userDetails.cinema_id :", this.userDetails.cinema_id);
      } else if (type == "department") {
        this.selected.Departments = value.dept_name;
        this.userDetails.department_id = value.dept_id;
      } else if (type == "distributor") {
        this.userDetails.d_id = value.d_id;
        this.selected.Distributor = value.d_company_name;
      } else if (type == "countrycode") {
        this.userDetails.country_mob_code = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "store") {
        this.userDetails["store_id"] = value.sm_id;
        this.userDetails["selectedStore"] = value;
      } else if (type === "store") {
        this.userDetails.store_id = event.sm_id;
      }

      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.errors.clear();
        this.$validator.resume();
        // console.log("object R :");
        this.$forceUpdate();
      });
    },
    removeHandler(type, event) {
      if (type == "store") {
        this.userDetails["store_id"] = null;
        this.userDetails["selectedStore"] = "";
      }
    },
    getDistributorsList: function () {
      let payload = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // console.log('cine_id :', cine_id);
      // let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      // MasterService.GlobalRequest(body)
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.Cinemas = x.cine_name;
                this.userDetails.cinema_id = x.cine_id;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getDepartmentList: function () {
      this.Departments = [];
      // let body = this.getRequestBody("GET", undefined, this.DepartmentsMethods);
      let payload = {
        tableName: "ms_departments",
        dept_is_active: "Y",
      };
      // MasterService.GlobalRequest(body)
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Departments = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getGenderList: function () {
      this.Gender = [];
      let payload = {
        tableName: "ms_gender",
        gender_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Gender = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getGenreList: function () {
      this.Genre = [];
      // let body = this.getRequestBody("GET", undefined, this.GenresMethod);
      let payload = {
        tableName: "ms_genre",
        g_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Genres = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    // getCountriesList: function () {
    //   this.Countries = [];
    //   let payload = {
    //     tableName: "ms_countries",
    //     country_is_active: "Y",
    //   };
    //   MasterService.GetActiveList(payload)
    //     .then((response) => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         // this.Countries = data.Records;
    //         // this.CodeListCopy = data.Records;
    //         // this.countryList = data.Records;
    //         const sortedCountries = data.Records.sort((a, b) =>
    //           a.country_name.localeCompare(b.country_name)
    //         );
    //         this.Countries = sortedCountries;
    //         this.CodeListCopy = [...sortedCountries];
    //         this.countryList = [...sortedCountries];
    //       } else {
    //         // Show Errors
    //         console.log("show error :", data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    getCountriesList: function () {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };

      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            const sortedCountryNames = [...data.Records].sort((a, b) =>
              a.country_name.localeCompare(b.country_name)
            );
            this.Countries = sortedCountryNames;

            const prioritizedCodes = ["002", "20"];
            const prioritized = data.Records.filter((c) =>
              prioritizedCodes.includes(c.country_mob_code)
            );
            const others = data.Records.filter(
              (c) =>
                c.country_mob_code &&
                !prioritizedCodes.includes(c.country_mob_code)
            ).sort((a, b) =>
              a.country_mob_code.localeCompare(b.country_mob_code)
            );

            const sortedCodeList = [...prioritized, ...others];
            // this.countryList = sortedCodeList;
            // this.CodeListCopy = sortedCodeList;
            const uniqueSortedCodeList = sortedCodeList.filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) => t.country_mob_code === item.country_mob_code
                )
            );

            this.countryList = uniqueSortedCodeList;
            this.CodeListCopy = uniqueSortedCodeList;

            if (!this.userDetails.country_mob_code) {
              const defaultCode = sortedCodeList.find(
                (c) => c.country_mob_code === "20"
              );
              if (defaultCode) {
                this.userDetails.country_mob_code =
                  defaultCode.country_mob_code;

                this.onSelectHandler("countrycode", defaultCode);
              }
            }
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getStatesList: function (country_id) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: country_id,
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.States = data.Records;
            this.States = data.Records.sort((a, b) => a.state_name.localeCompare(b.state_name));
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCountryHandler: function (country) {
      this.getStatesList(country.country_id);
    },
    onSelectStateHandler: function (state) {
      this.getCitiesList(state.state_id);
    },
    getCitiesList: function (state_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: state_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getRolesList: function () {
      this.Roles = [];
      let payload = {
        tableName: "ms_roles",
        role_is_active: "Y",
      };
      // let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      // MasterService.GlobalRequest(body)
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // if (data.Records.length > 0) {
            //   this.Roles = data.Records;
            //   this.RolesCopy = data.Records;

            //   if (this.loginRoleId == 3) {
            //     // this.selected.cinema_id = loginCinema_Id.;
            //     this.Roles = this.Roles.filter((singleRole) => {
            //       // console.log('singleRole :', singleRole.role_id != 2);
            //       if (singleRole.role_id != 2) {
            //         return singleRole;
            //       }
            //     });
            //     // console.log("this.Roles :", this.Roles);
            //   }
            // }
            let rolesData = data.Records;

            rolesData.sort((a, b) => a.role_name.localeCompare(b.role_name));

            if (this.loginRoleId == 3) {
              rolesData = rolesData.filter((role) => role.role_id != 2);
            }

            this.Roles = rolesData;
            this.RolesCopy = rolesData;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getDesignationList: function () {
      this.Designations = [];
      // let body = this.getRequestBody(
      //   "GET",
      //   undefined,
      //   this.DesignationsMethods
      // );
      let payload = {
        tableName: "ms_designations",
        designation_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Designations = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.userDetails["pos_location_access"] = this.selectedUserLocations
        .map((x) => x.user_id)
        .toString();
      console.log("...this.userDetails :", this.userDetails);
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.userDetails.country_mob_code) {
            return;
          }
          if (
            this.selected.Distributor.length == 0 &&
            this.userDetails.role_id == 9
          ) {
            /* if(role)bcoz edit was not working */
            // console.log("update User functionss 3");
            this.$toasted.show(this.messagedistributor);
            return this.messagedistributor;
          } else {
            this.userDetails.role_id == 9
              ? (this.userDetails.up_dob = "")
              : this.userDetails.up_dob;
            this.userDetails.role_id == 9
              ? (this.userDetails.up_doj = "")
              : this.userDetails.up_doj;
            if (
              false
              // this.userDetails.role_id != 9 &&
              // (!this.userDetails["gender_id"] ||
              //   String(this.userDetails.gender_id).length === 0)
            ) {
              this.$toasted.show("Please Select Gender");
            } else if (
              false
              // this.userDetails.role_id != 9 &&
              // (!this.userDetails["employeementSelectedType"] ||
              //   String(this.userDetails.employeementSelectedType).length === 0)
            ) {
              this.$toasted.show("Please Select Employement Type");
            } else if (
              !this.userDetails["role_id"] ||
              String(this.userDetails.role_id).length === 0
            ) {
              this.$toasted.show("Please Select Role ");
            } else if (
              this.loginRoleId !== 3 &&
              // ||
              //   this.userDetails.role_id == 4 ||
              //   this.userDetails.role_id == 8 ||
              //   this.userDetails.role_id == 7)
              (!this.userDetails["cinema_id"] ||
                String(this.userDetails.cinema_id).length === 0)
            ) {
              this.$toasted.show("Please Select Cinema ");
            } else if (
              ["4", "8"].includes(String(this.userDetails["role_id"])) &&
              !this.userDetails["store_id"]
            ) {
              return this.$toasted.show("Please Select Store Management");
            } else {
              this.btenable = true;

              UserService.AddUser({ ...this.userDetails, flag: this.flag })
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data.status) {
                    console.log("resert call");
                    this.onResetForm();
                    this.$toasted.success("Record Added successfully!");
                    if (redirect) {
                      // console.log("redirect value ",redirect);
                      this.$router.push({
                        path: "/user-management/users",
                      });
                    } else {
                      this.onResetForm();
                      this.submitted = false;
                      this.$toasted.show(data.error || data.message);
                    }
                  } else {
                    this.$toasted.show(data.error || data.message);
                  }
                })
                .catch(this._CatchError);
            }
          }
        } else {
          console.log("Valid Else :");
        }
      });
    },
    uploadImage: function (image) {
      // console.log("imagee",image);
      let loader = this.$loading.show();

      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "User Image");
      // formData.append("imagePath", "/uploads/users/");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.userDetails.user_profile_image_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    onChange2FA: function () {
      if (this.userDetails.TFA === "Y") {
        this.userDetails.use_only_authenticator = "N";
        this.onChangeUseOnlyAuthenticator();
      }
    },
    onChangeUseOnlyAuthenticator: function () {
      // this.userDetails.use_only_authenticator
      if (this.userDetails.use_only_authenticator === "Y") {
        this.userDetails.TFA = "N";
        this.fetchAuthenticatorCode();
      } else {
        this.showAuthenticatorQRCode = false;
        this.authenticatorQRCode = null;
        this.userDetails.authenticator_secret = "";
      }
    },
    fetchAuthenticatorCode() {
      UserService.GetAuthenticatorCode()
        .then(({ data }) => {
          if (data.status) {
            this.userDetails.authenticator_secret = data.data.base32;
            this.authenticatorQRCode = data.dataURL;
            this.showAuthenticatorQRCode = true;
          }
        })
        .catch((err) => {
          console.log("Error when fetching the qrcode data", err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/addUser.vue